import React from 'react';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider, withMsal } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';  // Import Bootstrap CSS
import 'jquery';  // Import jQuery
import 'bootstrap/dist/js/bootstrap.bundle.min.js';  // Import Bootstrap JS
import './index.css';
import App from './App';
import autoLogout from './components/autoLogout';
import * as serviceWorker from './serviceWorker';

// configure app to use azure settings in authConfig.js
//export const msalInstance = new PublicClientApplication(msalConfig);
const appAutoLogout = new autoLogout();
ReactDOM.render(
    // Auto-Refresh every five mins, set to 60 for testing, set to 300 for prod
    <React.StrictMode>
        {/* <MsalProvider instance={msalInstance}> */}
        <App />
        {/* </MsalProvider> */}
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
